// extracted by mini-css-extract-plugin
export default {"Login":"EmailVerify_Login__CBQBD"};